import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconArrowLeftOutlineStyle0 = gravityIconIndividualCss;

const GravityIconArrowLeftOutline = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '4b1aa46b3188ea2ce99f25a039192e1eb5e26cf6', color: this.color, size: this.size }, h("svg", { key: '02410666118fa01746616add85c0c92872f91b49', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '35fb7bcd8d9b4fee8592bfbd8c0a915cc2621966', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m6.56 11.09 5.83 5.82a.5.5 0 0 0 .71 0l.35-.35a.51.51 0 0 0 0-.71l-5.12-5.12 5.12-5.11a.51.51 0 0 0 0-.71l-.35-.35a.5.5 0 0 0-.71 0l-5.83 5.82a.51.51 0 0 0 0 .71Z", fill: "currentColor" }))));
    }
};
GravityIconArrowLeftOutline.style = GravityIconArrowLeftOutlineStyle0;

export { GravityIconArrowLeftOutline as gravity_icon_arrow_left_outline };

//# sourceMappingURL=gravity-icon-arrow-left-outline.entry.js.map